export default "__VITE_ASSET__baY1cBkp__"